import { createStore } from 'vuex';

// Since PADME-4663 every  Vuex module will register itself the first time is used.
// We no longer need to register them all in one single place
export const store = createStore({});
